import { Instance } from 'mobx-state-tree';
import { useState, useEffect } from 'react';

import { useStore } from '~/src/hooks/useMst';
import { Project } from '../stores/projectsStore';

const useFetchProject = (
  projectId: number,
  initialProject = false,
  getPDFElements = false,
  enabled?: boolean,
) => {
  const [loading, setLoading] = useState(true);
  const { projects } = useStore();

  const [project, setProject] = useState<
    Instance<typeof Project> | undefined
  >();

  const fetchProjectData = () => {
    if (initialProject) {
      setProject(projects.getProject(projectId));
      setLoading(false);
    } else {
      projects
        .fetchProject(projectId, getPDFElements)
        .then((nextProject: Instance<typeof Project>) => {
          setProject(nextProject);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (enabled === false) {
      return;
    }
    fetchProjectData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, initialProject, enabled]);

  return {
    project,
    loading,
  };
};

export default useFetchProject;
